<template>
    <div class="container" :style="{ 'min-height': bodyHeight + 'px' }">
        <navBar :title="title" @onClickLeft="handleBack">
        </navBar>
        <div class="container_pad">
            <img class="title" src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/entityCard/Incubation_img1_new.png" alt="">
            <div class="ercode_box">

                <img class="ercode" src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/entityCard/ercode.png" alt="">
                <div class="black">
                    扫码添加讲师<br>领取网红孵化秘籍
                </div>
            </div>
            <a class="recharge_btn" v-if="!iswx"
                href="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/entityCard/ercode.png?response-content-type=application/octet-stream" download>保存二维码</a>
            <div class="recharge_btn" v-if="iswx">长按图片保存二维码</div>
        </div>

    </div>
</template>


<script>
import navBar from '../components/navBar.vue';


export default {
    components: {
        navBar,
    },
    data() {
        return {
            iswx: false,
            actionData: {},
            title:this.$route.meta.title
        }
    },
    created() {
        this.iswx = this.WeiXin();
        this.bodyHeight = window.screen.height;
    },
    methods: {
        handleBack() {
            this.$router.go(-1);
        },
        WeiXin() {
            // 判断是否是微信内置浏览器
            let isWeiXin = () => {
                return (
                    navigator.userAgent
                        .toLowerCase()
                        .indexOf('micromessenger') !== -1
                )
            }
            if (isWeiXin()) {
                return true
            } else {
                return false
            }
        },
        show(item) {
            this.actionData = item;
        },
    },
}
</script>

<style lang="less" scoped>
.container {
    width: 100%;
    min-height: 100vh;
    background: linear-gradient(#96A6FD, #BB7FFF);    
}
.container_pad {
    padding: 31px 23px;
}

.title {
    width: 100%;
    height: 1026px;
    display: block;
    margin-bottom: 20px;
}
.ercode_box {
    position: relative;
    background: linear-gradient(93deg, #CA1DF0 0%, #714DFF 100%);
    padding: 25px 25px 25px 30px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    .ercode {
        width: 180px;
        height: 180px;
    }
    .black {
        width: 443px;
        height: 180px;
        background: #020000;
        display: flex;
        padding: 30px 62px;
        color: #fff;
        line-height: 53px;
        font-size: 28px;
        box-sizing: border-box;
    }
}

.recharge_btn {
    display: block;
    color: #fff;
    font-size: 30px;
    text-align: center;
    line-height: 80px;
    height: 80px;
    background: linear-gradient(90deg, #C94DF9 0%, #7E4CF8 100%);
    border-radius: 50px;
    margin-top: 40px;
}
</style>